export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const SET_CHANGED = "SET_CHANGED";
export const SHOW_WARRING_CHANGE_MESSAGE = "SHOW_WARRING_CHANGE_MESSAGE";

export const SET_BREADCRUMB = "SET_BREADCRUMB";

export const SET_EXPAND_CHART = "SET_EXPAND_CHART";
export const USER_WALLET = "USER_WALLET";
export const SET_GLOBAL_SETTING = "SET_GLOBAL_SETTING";
